import styled from "styled-components";

export const WrapperForgotPasswordStep = styled.h2`
  h2{
    padding-left: 6px
  }
`;